import { FC } from 'react';

import DropdownButton from '@/shared/components/dropdowns/DropdownButton';
import DropdownButtonSelect, {
    type DropdownButtonOption,
} from '@/shared/components/dropdowns/DropdownButton/DropdownButtonSelect';

import type { AdvancedFilterJoin } from '../advancedFilters';

interface FilterBooleanJoinSelectProps {
    disabled?: boolean;
    onChange: (value: AdvancedFilterJoin) => void;
    value: AdvancedFilterJoin;
}

const options: Array<DropdownButtonOption<AdvancedFilterJoin>> = [
    {
        description: 'Require this filter or group together with the preceding one.',
        label: 'And',
        value: 'and',
    },
    {
        description: 'Allow this filter or group as an alternative to the preceding one.',
        label: 'Or',
        value: 'or',
    },
];

const FilterBooleanJoinSelect: FC<FilterBooleanJoinSelectProps> = ({ disabled, onChange, value }) => (
    <DropdownButtonSelect<AdvancedFilterJoin>
        aria-label='Boolean filter operator'
        disabled={disabled}
        matchTriggerWidth={false}
        menuWidth='17rem'
        options={options}
        size='small'
        value={value}
        onChange={(nextValue) => {
            if (nextValue) {
                onChange(nextValue);
            }
        }}
    >
        <DropdownButton disabled={disabled} size='small' style={{ flex: 'none', minWidth: '4.5rem' }}>
            <small>{options.find((option) => option.value === value)?.label ?? 'And'}</small>
        </DropdownButton>
    </DropdownButtonSelect>
);

export default FilterBooleanJoinSelect;
